import { AuthService } from '@abp/ng.core';
import { Injectable, Injector, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AgentStatusAccessService } from '../agent-status/agent-status-access.service';
import { AuthorizationService } from '../auth/authorization.service';
import { AgentHeartbeatService } from '../signalr/agent-heartbeat.service';

@Injectable({ providedIn: 'root' })
export class SessionExitService {
  private readonly authService = inject(AuthService);
  private readonly authorizationService = inject(AuthorizationService);
  private readonly injector = inject(Injector);
  private readonly agentStatusAccess = inject(AgentStatusAccessService);
  private heartbeat: AgentHeartbeatService | null = null;

  async logout(queryParams?: Parameters<AuthService['logout']>[0]): Promise<void> {
    try {
      if (this.agentStatusAccess.canUseStatusManagement()) {
        await this.getHeartbeat().disconnect();
      }

      // Revoke the SignalR access-key cookie/cache entry before the end-session redirect below navigates
      // away - anything issued after that navigation starts may never leave the tab.
      await firstValueFrom(this.authorizationService.revokeAccessKey()).catch(() => undefined);
    } finally {
      await firstValueFrom(this.authService.logout(queryParams));
    }
  }

  private getHeartbeat(): AgentHeartbeatService {
    if (!this.heartbeat) {
      this.heartbeat = this.injector.get(AgentHeartbeatService);
    }

    return this.heartbeat;
  }
}
